<template>
  <div>
    <p class="category">Social Emotions to Online Topics</p>
    <div class="container text-left">
      <p>
        This task aims to predict social emotion to online discussion topics. While most prior tasks focus on emotions
        from writers, we investigate readers’ responses and explore the public feelings to an online topic.
      </p>
      <p>
        A large-scale dataset is collected from Chinese microblog Sina Weibo with thousand of trending topics, emotion
        votes in 24 fine-grained types from massive participants, and user comments to allow context understanding.
      </p>
      <p>
        The dataset is organized in the json format.
        The block below presents a piece of data.
      </p>
      <div>
        <json-tree :raw="data2str(instanceData)"></json-tree>
      </div>

      <div>
        <span class="h6 mr-2">Data resources: </span>
        <a href="/resource_social22/data/data_emotion.zip">data_emotion.zip</a>
      </div>
      <div>
        <span class="h6 mr-2">Baseline Implementation: </span>
        <a href="/resource_social22/data/src_emotion.ipynb">src_emotion.ipynb</a>
      </div>
      <p class="mt-3">Uploading results should be saved as a <strong>.txt</strong> file like this:</p>
      <v-card class="px-3 py-2">
        <div>0 [doge] [给力] [嘻嘻]</div>
        <div>1 [doge] [给力]</div>
        <div>2 [doge] [嘻嘻]</div>
        <div>3 [doge] [给力] [嘻嘻]</div>
        <div>4 [给力] [嘻嘻]</div>
      </v-card>
      <p>Where each row represents the candidate emotions (separated by space, no more than 3), and the first number
        represents the row ID.</p>
      <p>More information can be found through the published paper below.</p>
      <v-card class="pt-2">
        <v-md-editor mode="preview" ref="editor" height="100%" v-model="content" class="px-md-5"></v-md-editor>
      </v-card>
    </div>
  </div>
</template>

<script>
import JsonTree from "vue-json-tree";

export default {
  name: "taskEmotion",
  components: {JsonTree},
  data() {
    return {
      instanceData: {
        "hashtag": "20天后20后出生",
        "attitudes": ["[允悲]", "[跪了]", "[doge]"],
        "comments": ["90后抗住", "到了一个非常尴尬的年纪，二十上下", "20后看90后=90后看60后？！-。…哎呀 天呐 太可怕了😱-。…", "还有二十天，00后最大的就二十了，二十岁的老阿姨路过", "想到喊我大妈的都要出生了……90后的我哭了，我还是母胎单身啊啊啊啊", "00后突然就很紧张"]
      },
      content: `
\`\`\`
@inproceedings{ding-etal-2020-hashtags,
    title = "Hashtags, Emotions, and Comments: A Large-Scale Dataset to Understand Fine-Grained Social Emotions to Online Topics",
    author = "Ding, Keyang  and
      Li, Jing  and
      Zhang, Yuji",
    booktitle = "Proceedings of the 2020 Conference on Empirical Methods in Natural Language Processing (EMNLP)",
    month = nov,
    year = "2020",
    address = "Online",
    publisher = "Association for Computational Linguistics",
    url = "https://aclanthology.org/2020.emnlp-main.106",
    doi = "10.18653/v1/2020.emnlp-main.106",
    pages = "1376--1382",
}
\`\`\`
`,
    }
  },
  methods: {
    data2str(data) {
      return JSON.stringify(data);
    },
  }
}
</script>

<style scoped>

</style>